<template>
   <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div v-else>
          <!-- Keep-alive should wrap <router-view /> -->
         
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
            <div class="d-flex align-items-center">
         
                  
                  <span>
                     <h4 class="text-white">{{user_details.laundry_name}}</h4>
                  </span>
         
            
               <div class="d-flex align-items-center gap-2 ms-auto">
                   
                  <a class="toggle"  data-bs-toggle="offcanvas" data-bs-target="#menuSideBar"
                  aria-controls="menuSideBar" href="#">
                      <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
                      <i class="bi bi-list d-flex m-0 h4 text-white"></i>
                      </b>
                  </a>
               </div>
            </div>
            <!-- <div class="pt-3">
               
               <a href="#" data-bs-toggle="offcanvas" data-bs-target="#searchoffcanvas"
                  aria-controls="searchoffcanvas">
                  <div class="input-group bg-white rounded-3 shadow-sm py-1">
                     <input type="text" class="form-control bg-transparent border-0 rounded-0 px-3"
                        placeholder="Search here for more" aria-label="Search here for"
                        aria-describedby="search">
                     <span class="input-group-text bg-transparent border-0 rounded-0 pe-3" id="search"><i
                        class="icofont-search-1"></i></span>
                  </div>
               </a>
            </div> -->


         </div>
    
         <!-- body -->
         <div class="my-auto overflow-auto vh-100">
            <!-- shop by category -->
            <div class="bg-light pb-3 pt-3">
               <div class="container ">
            
               <div class="row">
                  <div class="col-4 ps-1"  >
                     <router-link :to="'/orderlist'" class="link-dark">
                        <div class="card border-0 text-center text-white  bg-danger ">
                           <h4>{{total_booking.total_booking??0}}</h4>
                           <div class="card-body p-0">
                              <div >
                                 <p class="card-title small m-0">{{language?.total_booking}}</p>
                                 </div>
                           </div>
                        </div>
                     </router-link>
                  </div>
                  <div class="col-4 ps-1 "  >
                     <router-link :to="'/orderlist'" class="link-dark">
                        <div class="card bg-success border-0 text-center text-white">
                           <h4>{{total_amt.total_amt??0}}</h4>
                           <div class="card-body p-0">
                              <div >
                                 <p class="card-title small m-0">{{language?.total_amt}}</p>
                                 </div>
                           </div>
                        </div>
                     </router-link>
                  </div>
                  <div class="col-4 ps-1 "  >
                     <router-link :to="'/orderlist'" class="link-dark">
                        <div class="card bg-dark border-0 text-center text-white">
                           <h4>{{total_due?.due_amt??0}}</h4>
                           <div class="card-body p-0">
                              <div >
                                 <p class="card-title small m-0">{{language?.due_amt}}</p>
                                 </div>
                           </div>
                        </div>
                     </router-link>
                  </div> 
               </div>
                  </div>
            </div>

            <h5 class="text-danger">{{laundry_details.acc_type==1?'':'Trial Expiring On '+laundry_details.acc_expiry}}</h5>
        


           



         
        

            <!-- Top Evets -->
            <div class="pt-1 bg_card">
               <div class="d-flex align-items-center justify-content-between px-1 pb-1">
                  <h5 :class="show_del_list?'fw-bold text-success mb-0':'fw-bold text-black mb-0'"  @click="show_del_list=true">{{language?.booking_list}}</h5>
                  <!-- <h5 :class="show_del_list?'fw-bold text-black mb-0':'fw-bold text-success mb-0'" @click="show_del_list=false">{{language?.delivery_list}}</h5>
                  <router-link v-if="show_del_list" :to="'/orderlist'" class="text-primary">{{language?.view_all}}<i class="icofont-rounded-right"></i></router-link>
                  <router-link v-if="!show_del_list" :to="'/deliverylist'" class="text-primary">{{language?.view_all}}<i class="icofont-rounded-right"></i></router-link> -->
                  <!-- <a class="text-primary" href="eventlist">View all<i class="icofont-rounded-right"></i></a> -->
               </div>
               <div class=" " v-if="show_del_list">
                  <!-- 1st item -->
                   <div class="  border-1 overflow-hidden col-12" v-for="(order,i) in filteredorderList"
               >
                
                        <div class="card card-body p-1">
                 <div class="text-muted">{{ language?.booking_id }}.{{order.id}} / {{ language?.Room_No }}. #{{order.room_no}}  <span class="float-right">{{ language?.only_date }}: {{order.iddate}}</span></div>
                 <div class="text-dark">
                  <strong>{{ order.cust_name }}/<a :href="'tel:' + order.cust_contact">{{ order.cust_contact }}</a>  ( {{ order.status == 1 ? 'Checked In' : 'Checked Out' }})</strong>
                </div>                
              <!-- <div class="text-muted">{{ language?.delivery_date }} : {{order.deliverydate}}&nbsp; 
              <span :class="order.status=='completed'?'badge bg-success':(order.status=='New Order'?'badge bg-dark':(order.status=='delivered'?'badge bg-dark text-white':'badge bg-warning text-dark'))"  >{{order.status}}</span></div> -->
                      <div class="row">

                              <div class="col-6" style="color: black;">{{ language?.check_in }}</div>
                              <div class="col-6" style="color: black;">{{ language?.check_out }}</div>

                              <div class="col-6" style="color: red;"> {{order.fromdate  }}</div>
                              <div class="col-6" style="color: red;">  {{order.todate}}</div>

                        
                      </div>


              <div class="row">
                <div class="col-4" style="color: black;">{{ language?.total }}</div>
                <div class="col-4" style="color: black;">{{ language?.paid }}</div>
                <div class="col-4" style="color: black;">{{ language?.due }}</div> 


                <div class="col-4" style="color: red;"> {{order.totalamt}}</div>
                <div class="col-4" style="color: red;">  {{order.paidamt}}</div>
                <div class="col-4" style="color: red;">{{ order.totalamt - order.paidamt }}</div>
            </div>  
            
              <div>
                <router-link :to="'/orderDetails?id='+order.id" >
                <span class="badge bg-success">
                  <i class="bi bi-eye"></i> &nbsp; {{ language?.view }}
                </span> &nbsp; &nbsp;
              </router-link>

              <!-- <router-link :to="'/allbooking_list?id='+order.custid" >
                <span class="badge bg-success">
                  <i class="bi bi-eye"></i> &nbsp; {{ language?.all_order }}
                </span>
              </router-link> &nbsp; &nbsp; -->

              <!-- <span class="badge bg-danger" @click="deleteorder(order.id)"><i class="bi bi-trash"></i> &nbsp; Delete</span>&nbsp; &nbsp;  -->

              <!--<span class="badge bg-success">{{order.status}}</span>-->
              </div>

            </div>
                
            </div>
                  
               </div> 
                 <div class=" " v-if="!show_del_list">
                  <!-- 1st item -->
                   <div class="  border-1 overflow-hidden col-12" v-for="(order,i) in filtereddeliveryList"
               >
                <router-link :to="'/orderDetails?id='+order.id" >
                      <div class="card card-body p-1">
                <div class="text-muted">{{ language?.bill_no }}. #{{order.billno}}  <span class="float-right">{{ language?.date }}: {{order.billdate}}</span></div>
                <div class="text-dark">
                  <strong>{{ order.cust_name }}/<a :href="'tel:' + order.cust_contact">{{ order.cust_contact }}</a></strong>
                </div>  
                <div class="text-muted">{{ language?.delivery_date }}: {{order.deliverydate}}&nbsp; 
                <!--<span :class="order.status=='completed'?'badge bg-success':(order.status=='New Order'?'badge bg-dark':'badge bg-warning text-dark')"  >{{order.status}}</span></div>-->
                 <span :class="order.status=='completed'?'badge bg-success':(order.status=='New Order'?'badge bg-dark':(order.status=='delivered'?'badge bg-dark text-white':'badge bg-warning text-dark'))"  >{{order.status}}</span></div>
                <div class="row">
                  <div class="col-4" style="color: black;">{{ language?.total }}</div>
                  <div class="col-4" style="color: black;">{{ language?.paid }}</div>
                  <div class="col-4" style="color: black;">{{ language?.due }}</div> 
  
  
                  <div class="col-4" style="color: red;"> {{ order.total }}</div>
                  <div class="col-4" style="color: red;">  {{ order.paidamt }}</div>
                  <div class="col-4" style="color: red;">{{ order.total - order.paidamt }}</div>
              </div>  
                <div>
                  <span class="badge bg-success">
                    <i class="bi bi-eye"></i> &nbsp; {{ language?.view }}
                  </span> &nbsp; &nbsp;

                  <router-link :to="'/allorderlist?id='+order.custid" >
                     <span class="badge bg-success">
                       <i class="bi bi-eye"></i> &nbsp; {{ language?.all_order }}
                     </span>
                   </router-link> &nbsp; &nbsp;

                   <span class="badge bg-danger" @click="deleteorder(order.id)"><i class="bi bi-trash"></i> &nbsp; {{language?.delete}}</span>&nbsp; &nbsp; 
                   <!--<span :class="order.status=='completed'?'badge bg-success':(order.status=='New Order'?'badge bg-dark':'badge bg-warning text-dark')" >{{order.status}}</span>-->
                </div>
              </div> 
                </router-link>
            </div>
                  
               </div> 
            </div>

       


 


  
         </div>
         <!-- category button -->
         <div class="btn-category" v-if="isbutton">
            <a @click="checkUserLogged()" class="btn btn-primary rounded-circle shadow-sm icon-lg plus-color"  >
               <i class="icofont-plus icofont-3x text-white"></i>
            </a>
         </div>
         <!--   -->
         <div class="footer bg-white shadow mt-auto border-top">
            <div class="d-flex align-items-center justify-content-between py-1">
                  <router-link :to="'/home'" class="link-dark text-center col py-2 p-1">
                  <i class="bi bi-house h3 m-0"></i>
                  <p class="small m-0 pt-1">{{language?.Home}}</p>
               </router-link>
               <router-link :to="'/roomview'" class="link-dark text-center col py-2 p-1">
                  <i class="bi bi-plus-circle h3 m-0"></i>
                  <p class="small m-0 pt-1">{{language?.booking}}</p>
               </router-link>
               <router-link :to="'/orderlist'" class="link-dark text-center col py-2 p-1">
                  <i class="bi bi-list  h3 m-0"></i>
                  <p class="small m-0 pt-1">{{language?.booking_list}}</p>
               </router-link>
               <router-link :to="'/customerlist'" class="link-dark text-center col py-2 p-1">
                  <i class="bi bi-list-ol h3 m-0"></i>
                  <p class="small m-0 pt-1">{{language?.customer_list}}</p>
               </router-link>
               <a @click="checkUserprofile()" class="text-muted text-center col py-2 p-1">
                  <i class="bi bi-person h3 m-0"></i>
                  <p class="small m-0 pt-1">{{language?.Home}}</p>
               </a>
            </div>
         </div>





         <!-- SIDEBAR -->
        <div class="offcanvas offcanvas-start border-0 mid_width" tabindex="-1" id="menuSideBar" aria-labelledby="menuSideBar">
            <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
                <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
                <h6 class="offcanvas-title text-white m-0" id="menuSideBar">Menu</h6>
            </div>
        <div class="offcanvas-body">
                  <ul class="second-nav">
                        <li @click="navTo('/home')"> <i class="bi bi-house me-3"></i>{{language?.homepage}} </li>
                        <li v-if="isBranchAllowed" @click="navTo('/branch')"> <i class="bi bi-shop me-3"></i>{{language?.menu_branch}}</li>
                        <!-- <li v-if="isUserAllowed" @click="navTo('/user')"><i class="bi bi-person me-3"></i>{{language?.menu_user}} </li>
                        <li @click="navTo('/products')"><i class="bi bi-basket me-3"></i>{{language?.menu_product}} </li>
                        <li @click="navTo('/services')"><i class="bi bi-box me-3"></i>{{language?.menu_service}}</li>
                        <li @click="navTo('/cost')"><i class="bi bi-card-checklist me-3"></i>{{language?.menu_cost}}</li> 
                        <li @click="navTo('/report')"><i class="bi bi-bar-chart me-3"></i>{{language?.menu_report}}</li>
                        <li @click="navTo('/daywisereport')"><i class="bi bi-calendar-date me-3"></i>{{language?.menu_day_wise_report}}</li>
                        <li @click="navTo('/accounting')"><i class="bi bi-currency-rupee me-3"></i>{{language?.menu_accounting}}</li> 
                        <li @click="navTo('/accountinghistory')"><i class="bi bi-house me-3"></i>{{language?.menu_accounting_history}}</li>
                        <li @click="navTo('/orderlist')"><i class="bi bi-list me-3"></i>{{language?.order_list}}</li>
                        <li @click="navTo('/deliverylist')"><i class="bi bi-truck me-3"></i>{{language?.delivery_list}}</li> -->
                            <li @click="navTo('/RoomCategory')"><i class="bi bi-truck me-3"></i>{{language?.Room_Category}}</li>
                            <li @click="navTo('/addroom')"><i class="bi bi-truck me-3"></i>{{language?.Add_Room}}</li>
                             <li @click="navTo('/roomview')"><i class="bi bi-truck me-3"></i>{{language?.Room_View}}</li>
                             <li @click="navTo('/AddClass')"><i class="bi bi-truck me-3"></i>{{language?.class}}</li>
                             <li @click="navTo('/AddStaff')"><i class="bi bi-truck me-3"></i>{{language?.add_staff}}</li>
                             <!-- <li @click="navTo('/AddStudent')"><i class="bi bi-truck me-3"></i>{{language?.add_studnet}}</li>
                            <li @click="navTo('/Attendance')"><i class="bi bi-truck me-3"></i>{{language?.attendance}}</li>
                             <li @click="navTo('/AttendanceReport')"><i class="bi bi-truck me-3"></i>{{language?.attendance_report}}</li> -->
                            <li @click="navTo('/StaffLogin')"><i class="bi bi-truck me-3"></i>Staff Login</li>
                  </ul>
                 
         </div>
      </div>
      
 
         
      </div>
    </div>
</template>
<style> 
.bg_card{
  background: #ededec;
    margin: 10px 0px;
    padding-bottom: 10px;
}  
.mid_width{
        width: 250px !important;
}


</style>
<style scoped>
    .second-nav{
    list-style: none;
        padding: 0;
}
.second-nav li{
    padding: 7px 0px;
    border-bottom: 1px solid grey;
}
</style>
<script> 
import axios from "@/plugins/axios";  
import { ref } from 'vue';
export default {
  name: 'HomeView',
  components: { 
  },
  mounted() {
    this.initializeHomeContent();
//   var $main_nav = $('#main-nav');
//     var $toggle = $('.toggle');
//     var defaultOptions = {
//         disableAt: false,
//         customToggle: $toggle,
//         levelSpacing: 40,
//         navTitle: 'App',
//         levelTitles: true,
//         levelTitleAsBack: true,
//         pushContent: '#container',
//         insertClose: 2
//     };
//     var Nav = $main_nav.hcOffcanvasNav(defaultOptions);
    
    
   //  this.fetchWeather();
    this.getHomeBasic(); // Call the method here
},
  data() {
    return {
         profile:[],   
         isBranchAllowed:true,
         isUserAllowed:true,
      isbutton:false,
      loading:false,
      error:null,
      isUserLogged:false,
      user_details:[],
      searchQuery: "", // Stores the search input value
     
        total_booking:0,
        total_amt:0,
        total_booking:0,
        
        
        filteredorderList:[],
        filtereddeliveryList:[],
        orderList: [],
        language:this.getLocalStorageArray('lang'),
        show_del_list:true,
        laundry_details:{"acc_type":1},
    }
  },
  methods:{
    initializeHomeContent(){
    

    },
    
navTo(route){
        this.$router.push(route);

    },
checkUserLogged(){
  if(!this.isUserLogged){
         this.$router.push({ name: 'register' });
   } else if(this.isUserLogged){
      this.$router.push({ name: 'form' });
    }else{

    }
},
checkUserprofile(){
  if(!this.isUserLogged){
         this.$router.push({ name: 'register' });
   } else if(this.isUserLogged){
      this.$router.push({ name: 'profile' });
    }else{

    }
},

 
 
    async getHomeBasic() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getUserDetails").then((response) => {
               if( response.data.logged){
                     self.isUserLogged=response.data.logged;
                     self.user_details=response.data.userdeatils;

                     self.booking_list=response.data.booking_list;


                     self.filteredorderList=self.booking_list;
                     self.filtereddeliveryList=response.data.booking_list;

               
                     
                     self.laundry_details=response.data.laundry_details;
                     if(!self.laundry_details || !self.laundry_details.name )
                     {
                        window.location.replace("/registerlaundry");
                     }
                     self.total_booking=response.data.total_booking;
                     self.total_amt=response.data.total_amt;
                     self.total_due=response.data.total_due;
                     self.language=response.data.language;
                     if(self.laundry_details?.expired==1){
                       localStorage.removeItem("token"); 
                       window.location.replace("/");
                     }
                     
                     localStorage.setItem('lang',response.data.language);
                     
                     
                     
                     

               }else{
                  localStorage.removeItem("token"); 
                  self.$router.push('/');
               } 
        
          }).then(() => {
               self.initializeHomeContent();
              
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 

      deleteorder(id = "") {
    this.loading = true;
    this.error = null;

    try {
        var self = this;

        this.$swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post("deleteorderlist", { id: id,from:'Home' }).then((response) => {
                    
                     self.orderList=response.data.order_list;
                     self.filteredorderList=self.orderList;
                     self.filtereddeliveryList=response.data.deliveryList;
                     
                    self.$swal.fire(response.data.message);
                }).then(() => {
                    
                    
                    self.initializeHomeContent();
                }).catch((err) => {
                    self.$swal.fire("Error!", "Something went wrong.", "error");
                });
            }
        });

    } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
    } finally {
        this.loading = false;
    }
},




      filterList() {
         alert(searchQuery);
      console.log("Filter function triggered!");
      // Implement your filtering logic here
    },


      getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    }
}
 
}






</script>
